/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Card, Col, Image, Row,
} from 'react-bootstrap';

import { __ } from '../../../helpers/translations';
import Section from '../../common/Section';

import SectionHeader from './SectionHeader';

const teamMembers = [
  {
    name: "Thomas O'Neill",
    img: './resources/our_team_tom.jpg',
    text: __('G305'),
    link: {
      text: 'https://profiles.ucalgary.ca/thomas-oneill',
      url: 'https://profiles.ucalgary.ca/thomas-oneill',
    },
  },
  {
    name: 'Nicole Larson',
    img: './resources/our_team_nicole.jpg',
    text: __('G306'),
    link: {
      text: 'https://experts.deakin.edu.au/53954-nicole-larson',
      url: 'https://experts.deakin.edu.au/53954-nicole-larson',
    },
  },
  {
    name: 'Samantha Jones',
    img: './resources/our_team_samantha.jpg',
    text: __('G307'),
    link: {
      text: 'https://profiles.ucalgary.ca/samantha-jones-2',
      url: 'https://profiles.ucalgary.ca/samantha-jones-2',
    },
  },
  {
    name: 'Zaw Enright',
    img: './resources/our_team_zaw.jpg',
    text: __('G308'),
    link: {
      text: 'https://www.linkedin.com/in/zaw-enright/',
      url: 'https://www.linkedin.com/in/zaw-enright/',
    },
  },
];

function OurTeam() {
  return (
    <Section bg="light">
      <SectionHeader
        title={__('G300')}
        subtitle=""
      />
      <Row className="my-3 g-6 justify-content-md-center">
        {teamMembers.map((resource, index) => (
          <Col lg={6} key={`our-team-${index}`} style={{ minHeight: '400px', height: '400px', paddingTop: '30px' }}>
            <Card className="card-span h-100" style={{ paddingTop: '30px' }}>
              <Card.Body>
                <div
                  className="card-span-img"
                  style={{ height: '100px', width: '100px', marginTop: '-50px' }}
                >
                  <Image src={resource.img} alt={resource.name} className="h-75 w-75" roundedCircle />
                </div>
                <Card.Title as="h5">
                  {resource.name}
                </Card.Title>
                <Card.Text>
                  {resource.text}
                </Card.Text>
                {resource.link && (
                <a href={resource.link.url} target="_blank" rel="noreferrer">
                  {resource.link.text}
                </a>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

    </Section>
  );
}

export default OurTeam;
